import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JarwisService } from 'src/app/Services/jarwis.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { emailValidator, matchingPasswords } from '../../../theme/utils/app-validators';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-response-reset',
  templateUrl: './response-reset.component.html',
  styleUrls: ['./response-reset.component.scss']
})
export class ResponseResetComponent implements OnInit {

  public showInfoContent: boolean = false;
  public error = [];
  public form: FormGroup;
  FormGroup: any;
  resetToken: any;


  // public form:FormGroup;
  public settings: Settings;
  constructor(private route: ActivatedRoute, public appSettings: AppSettings, public fb: FormBuilder, public router: Router, private jarwis: JarwisService, private toastr: ToastrService) {
    this.settings = this.appSettings.settings;
    route.queryParams.subscribe(params => {
      this.resetToken = params['token']
    }
    )
  }

  isSpace(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }

  onSubmit(values) {

    values['token'] = this.resetToken;

    if (this.form.valid) {
      if (values.password == values.c_password) {
        // values['email'] = btoa(this.form.controls.email.value);
        // values['password'] = btoa(this.form.controls.password.value);
        // values['c_password'] = btoa(this.form.controls.c_password.value);
        // this.jarwis.resetpassword(values).subscribe(
        //   data => this.handleResponse(data),
        //   error => this.handleError(error)
        // );        
        let tempEmail = this.form.controls.email.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        values['email'] = encryptedEmail;
        values['password']  = shajs('sha512').update(this.form.controls.password.value + values['email']).digest('hex');
        values['c_password'] = shajs('sha512').update(this.form.controls.c_password.value + values['email']).digest('hex');
        // console.log(values);
        this.jarwis.resetpassword(values).subscribe(
          data => this.handleResponse(data),
          error => this.handleError(error)
        );
      } else {
        this.toastr.error('Password confirmation does not match!');
      }
    }
    else {
      this.toastr.error('Incorrect details');
      this.form.reset();
    }
  }


  handleResponse(data) {
    if(data['type'] == 'success') {
      this.toastr.success(data['message']);
      this.router.navigateByUrl('/login');
    } else{
      this.toastr.error(data['message']);
      this.form.reset();
    }
  }

  handleError(error) {
    if (error.error.errors.email != null)
      if (error.error.errors.password != null) {
      }
  }


  isNumKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode >= 48 && charCode <= 57) || charCode == 45)
      return true;

    return false;
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode >= 48 && charCode <= 57)
      return true;

    return false;
  }

  isCharKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode >= 48 && charCode <= 57)
      return false;

    return true;
  }

  ngOnInit() {
    this.form = this.fb.group({
      'email': [null, Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$')])],
      'password': [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      'c_password': [null, Validators.compose([Validators.required, Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/])(?=.*[A-Z])(?=.*[a-z]).*$')])]
    });
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }

}
